import { Compass, Users, Gift, HeartHandshake } from "lucide-react";
import { useTranslation } from "react-i18next";
import Reveal from "./Reveal";

const ICONS = [Compass, Users, Gift, HeartHandshake];

export default function UseCases() {
  const { t } = useTranslation();
  const CASES = t("useCases.cases", { returnObjects: true }).map((c, i) => ({ ...c, icon: ICONS[i] }));

  return (
    <section id="bodegas" data-testid="use-cases-section" className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <Reveal className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.28em] text-[#F5CB5C] font-semibold">{t("useCases.kicker")}</div>
        <h2 className="mt-4 font-display text-white text-2xl sm:text-3xl lg:text-4xl leading-tight">
          {t("useCases.title1")} <span className="text-gold-gradient">{t("useCases.titleHighlight")}</span>{t("useCases.titleEnd")}
        </h2>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
        {CASES.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.1}>
            <article
              data-testid={`use-case-card-${i}`}
              className="glass-card glass-lift rounded-3xl p-6 sm:p-7 h-full relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(163,29,61,0.18),transparent_60%)] pointer-events-none" />
              <div className="relative">
                <div className="flex items-center justify-between">
                  <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#871430] to-[#540F20] border border-[#F5CB5C]/40 flex items-center justify-center shadow-[0_0_16px_rgba(245,203,92,0.15)]">
                    <c.icon size={21} className="text-[#F5CB5C]" />
                  </span>
                  <span className="font-display text-3xl text-white/10">0{i + 1}</span>
                </div>
                <h3 className="mt-5 font-display text-white text-lg">{c.title}</h3>
                <p className="mt-3 text-sm text-gray-400 leading-relaxed">{c.text}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
